// extracted by css-extract-rspack-plugin
export default {"orgsColumn__grid":"orgsColumn__grid-M1KC1_","orgsColumnGrid":"orgsColumn__grid-M1KC1_","orgsColumn__item":"orgsColumn__item-VT6WNs","orgsColumnItem":"orgsColumn__item-VT6WNs"};